module.exports = __webpack_public_path__ + "img/icon_home.99355b59.svg";